<template>
    <div>
        <modal-wrapper :open.sync="open" :title="$t('overlays.bankstatus.headline')" matomo-name="Bankstatus" wide>
            <div class="bankstatus-table">
                <table>
                    <thead>
                        <tr>
                            <th class="service-header">{{ $t('overlays.bankstatus.text.table-headline') }}</th>
                            <th
                                class="service-header"
                                v-for="level in bankstatus"
                                :key="level.NAME"
                                :class="'status-' + level.NAME"
                            >
                                <span class="current-state-label" v-if="isCurrentTarriff(level.NAME)">{{
                                    $t('overlays.bankstatus.text.current-state')
                                }}</span>
                                <!--
                        <app-icon
                            v-if="level.NAME !== 'classic'"
                            custom-class="icon"
                            :icon="`${level.NAME}-trophy`"
                            size-px="64px"
                        />
                        -->
                                <span>
                                    {{ $t('bankstatus.levels.' + level.NAME + '.short_name') }}
                                </span>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr
                            v-for="(advantage, index) in advantages"
                            :key="`advantage-${index}`"
                            :class="{ 'first-of-category': advantage.solid_top }"
                        >
                            <th class="left-column">
                                <div class="icon-wrapper">
                                    <app-icon custom-class="small-icon" size-px="24px" :icon="advantage.icon" />
                                </div>
                                <p v-html="$t(advantage.text)" />
                            </th>
                            <td
                                v-for="(level, innerIndex) in ['classic', 'bronze', 'silver', 'gold', 'platin']"
                                :key="`${index}-${innerIndex}`"
                                :class="{
                                    'no-benefit': advantage[level] === 'no-benefits',
                                }"
                            >
                                {{ text(advantage[level]) }}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <p class="small-text" v-html="$t('overlays.bankstatus.text.info')" />
        </modal-wrapper>
    </div>
</template>

<script>
import ModalWrapper from '@/components/modal/ModalWrapper';
import AppIcon from '@/components/AppIcon';
import { BANKSTATUS } from '@/helpers';
import EventBus from '@/eventBus';

export default {
    name: 'BankStatusModal',
    components: { AppIcon, ModalWrapper },
    data() {
        return {
            open: false,
            advantages: [
                {
                    icon: 'hand-square',
                    text: 'overlays.bankstatus.text.modules-requirements',
                    classic: 'ab 0',
                    bronze: 'ab 5',
                    silver: 'ab 8',
                    gold: 'ab 11',
                    platin: 'ab 14',
                },
                {
                    solid_top: true,
                    icon: 'liquiditaet-small',
                    text: 'overlays.bankstatus.text.account-benefit',
                    classic: 'no-benefits',
                    bronze: '2 €',
                    silver: '4 €',
                    gold: '8 €',
                    platin: '16 €',
                },
                /*{
                    icon: 'cash-bag',
                    text: 'overlays.bankstatus.text.custody-fee',
                    classic: '10.000 €',
                    bronze: '75.000 €',
                    silver: '125.000 €',
                    gold: '225.000 €',
                    platin: '9 €',
                },*/
                {
                    icon: 'email',
                    text: 'overlays.bankstatus.text.events',
                    classic: '5',
                    bronze: '5',
                    silver: '30',
                    gold: '60',
                    platin: '100',
                },
                /*{
                    icon: 'cash-bag',
                    text: 'overlays.bankstatus.text.discount',
                    classic: 'no-benefits',
                    bronze: 'no-benefits',
                    silver: '3 %',
                    gold: '3 %',
                    platin: '9 €',
                },
                {
                    icon: 'cash-bag',
                    text: 'overlays.bankstatus.text.coupon',
                    classic: 'no-benefits',
                    bronze: 'no-benefits',
                    silver: 'no-benefits',
                    gold: '50 €',
                    platin: '9 €',
                },*/
            ],
        };
    },
    computed: {
        bankstatus() {
            return BANKSTATUS;
        },
    },
    mounted() {
        EventBus.$on('modal-bankstatus', this.openModal);
    },
    beforeDestroy() {
        EventBus.$off('modal-bankstatus');
    },
    methods: {
        openModal() {
            this.open = true;
            this.$matomo && this.$matomo.trackEvent('Modals', 'open', 'Bankstatus');
        },
        text(value) {
            switch (value) {
                case 'no-benefits':
                    return this.$t('overlays.bankstatus.text.no-benefits');
                case 'check':
                    return '✓';
                default:
                    return value;
            }
        },
        tariffClass(tariff) {
            let cssclass = 'status-' + tariff;
            if (this.isCurrentTarriff(tariff)) {
                cssclass += ' is-active';
            }
            return cssclass;
        },
        isCurrentTarriff(tariff) {
            return tariff === this.getBankStatus;
        },
    },
};
</script>
